import "@fontsource/josefin-sans";
import { Col, Container, Row } from 'react-bootstrap';
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import './Banner.css';
import {authContext} from "../../../Context/AuthContext"



const Banner = () => {
    const {role} = useContext(authContext)
    return (
            <section className="single-hero-slide text-white d-flex justify-content-center align-items-center">
                <Container>
                    <Row className="align-items-center">
                        <Col md={12} sm={12} lg={6}>
                            <div className="hero-slide-left justify-content-end align-items-center text-center text-lg-start">
                                <h2>Better Life Through</h2>
                                <h1>Better Health</h1>
                                <p className="mb-xs-5">Join us to a fun and friendly Healthy environment. Our professionals are working so hard to see smile on your face that you deserve! We are dedicated about our duties.</p>
                                <div className="banner-btn m-sm-auto">
                                    <Link to={role == "user" ? "/doctorDash" : "/patient/createappointment/addDoctorEmailHere" }><button className="theme-btn btn-fill">{role == "user" ? "Doctor Dashboard" : "Appointment"}</button></Link>
                                </div>
                            </div>
                        </Col>
                        <Col md={12} sm={12} lg={6} className="mt-sm-5">
                            <div className="hero-slide-right text-center text-lg-start mt-sm-5">
                                <div className="animate-img">
                                    <img src={`${process.env.REACT_APP_STATIC_URL}/woman-brush.c4158ac5.jpeg`} alt="" className="img-fluid aimg1" />
                                    <img src={`${process.env.REACT_APP_STATIC_URL}/doctorfinding.c2532ac3.jpeg`} alt="" className="img-fluid aimg2" />
                                </div>
                                <img src={`${process.env.REACT_APP_STATIC_URL}/hero-theeth.54c2c4e9.jpeg`} alt="" className="heroTeeth"/>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
    );
};

export default Banner;